var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-time-five.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00016 1.33331C4.32416 1.33331 1.3335 4.32398 1.3335 7.99998C1.3335 11.676 4.32416 14.6666 8.00016 14.6666C11.6762 14.6666 14.6668 11.676 14.6668 7.99998C14.6668 4.32398 11.6762 1.33331 8.00016 1.33331ZM8.00016 13.3333C5.0595 13.3333 2.66683 10.9406 2.66683 7.99998C2.66683 5.05931 5.0595 2.66665 8.00016 2.66665C10.9408 2.66665 13.3335 5.05931 13.3335 7.99998C13.3335 10.9406 10.9408 13.3333 8.00016 13.3333Z",
    fill: "#5D5D75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.66683 4.66669H7.3335V8.27602L9.52883 10.4714L10.4715 9.52869L8.66683 7.72402V4.66669Z",
    fill: "#5D5D75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.e8f647b7e06fd4cddb5080de81a2f1df.svg";
export { ForwardRef as ReactComponent };